import { ReprocessamentoComponent } from '../reprocessamento/reprocessamento.component';
import { RelatorioArquivosPendentesComponent } from '../relatorio-arquivos-pendentes/relatorio-arquivos-pendentes.component';
import { RelatorioArquivosPorEmpresaComponent } from '../relatorio-arquivos-por-empresa/relatorio-arquivos-por-empresa.component';
import { RelatorioMapeamentoPorCidadesComponent } from '../relatorio-mapeamento-por-cidades/relatorio-mapeamento-por-cidades.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';

import { MonitorErroComponent } from '../monitor/listagem/monitor-erro/monitor-erro.component';
import { EmpresaListarComponent } from '../empresa/listar/listar.component';
import { EditarComponent } from '../empresa/id-empresa/editar/editar.component';
import { AplicativoCredenciamentoComponent } from '../credenciamento/aplicativo/aplicativo-credenciamento.component';
import {LoginComponent} from '../login/login.component';
import {AfterLoginService} from '../services/after-login.service';
import {CadastrarMunicipioEmpresaComponent} from '../cadastrar-municipio-empresa/cadastrar-municipio-empresa.component';

import { MonitorClientesComponent } from '../monitor-clientes/listar/monitor-clientes.component';
import { MonitorPendenciasComponent } from '../monitor/listagem/monitor-pendencias/monitor-pendencias.component';
import { DashboardComponent } from '../dashboard/generico/dashboard.component';
import {MonitorLinksComponent} from "../monitor/listagem/monitor-links/monitor-links.component";

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        children: [
            {
                path: 'login',
                component: LoginComponent,
                canActivate: []
            },
        ]
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
    },
    {
        path: 'credenciamento',
        children: [
            {
                path: 'aplicativo',
                component: AplicativoCredenciamentoComponent,
                canActivate: [AfterLoginService],
            }
        ]
    },
    {
        path: 'monitor/listar',
        children: [
            {
                path: 'erros',
                component: MonitorErroComponent,
                canActivate: [AfterLoginService],
            },
            {
                path: 'pendencias',
                component: MonitorPendenciasComponent,
                canActivate: [AfterLoginService],
            },
            {
                path: 'pendencias/links',
                component: MonitorLinksComponent,
                canActivate: [AfterLoginService],
            },
        ],
    },
    {
        path: 'monitor-clientes/listar',
        component: MonitorClientesComponent,
        canActivate: [AfterLoginService]
    },
    { path: 'relatorio-mapeamento-cidades', component: RelatorioMapeamentoPorCidadesComponent, canActivate:[AfterLoginService] },
    { path: 'relatorio-arquivos-por-empresa', component: RelatorioArquivosPorEmpresaComponent, canActivate:[AfterLoginService] },
    { path: 'relatorio-arquivos-pendentes', component: RelatorioArquivosPendentesComponent, canActivate:[AfterLoginService] },
    { path: 'reprocessamento', component: ReprocessamentoComponent, canActivate:[AfterLoginService] },
    {path: 'cadastrar-municipio-empresa', component: CadastrarMunicipioEmpresaComponent, canActivate:[AfterLoginService]},
    {path: 'vinculo-municipio-empresa/:id', component: CadastrarMunicipioEmpresaComponent, canActivate:[AfterLoginService]},
    {
        path: 'pdf/:id',
        component: MonitorErroComponent,
        canActivate:[AfterLoginService],
    },
    {
        path: 'empresa',
        children: [
            {
                path: 'listar',
                component: EmpresaListarComponent,
                canActivate:[AfterLoginService],
            },
            {
                path: ':id/editar',
                component: EditarComponent,
                canActivate:[AfterLoginService],
            }
        ]
    }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, {useHash: true})],
})
export class AppRoutingModule {
  constructor(private router: Router) {
    this.router.errorHandler = (error: any) => {
      if (error.message.includes('Cannot match any routes. URL Segment')){
        alert('A rota que você acessou não existe');
          this.router.navigateByUrl('/');
      }
      console.error(error);
    }
  }
}




